import CheckboxPart from './CheckboxPart';

export default CheckboxPart;